(() => {
  'use strict';
  if (document.documentElement.dataset.gosEnabled !== 'true') return;
  function initialize(scope = document) {
    scope.querySelectorAll('[data-gos-pack]').forEach(module => {
      if (module.dataset.ready) return;
      const form = module.closest('form');
      const section = module.closest('[data-product-section]');
      const button = form?.querySelector('[data-add-to-cart]');
      if (!form || !button) return;
      const label = button.querySelector('span') || button;
      button.disabled = true;
      const error = module.querySelector('[data-gos-pack-error]');
      const showError = message => {error.textContent=message;error.hidden=!message;};
      let data;
      let parentVariants;
      try {
        data = JSON.parse(module.querySelector('[data-gos-pack-data]').textContent);
        parentVariants = JSON.parse(form.querySelector('[data-product-variants]').textContent);
        if (!Array.isArray(data.variants) || !window.GosBundleCore) throw new Error('Invalid configuration');
      } catch (_) {showError('Composition indisponible. Rechargez la page avant de réessayer.');return;}
      module.dataset.ready = 'true';
      const choice = module.querySelector('[data-gos-pack-choice]');
      const mainVariant = form.querySelector('[data-variant-select]');
      const money = cents => new Intl.NumberFormat('fr-FR',{style:'currency',currency:module.dataset.currency}).format(cents/100);
      let selection;
      let submitting = false;
      const update = () => {
        const id = Number(choice?.value || mainVariant.value);
        selection = data.variants.find(variant => variant.id === id);
        const parent = parentVariants.find(variant => variant.id === id);
        mainVariant.value=String(id);
        if (parent) section?.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:parent}}));
        const list = module.querySelector('[data-gos-pack-lines]');
        list.replaceChildren();
        for (const item of selection?.components || []) {
          const li=document.createElement('li');
          const link=document.createElement('a');
          link.href=item.url || '#';
          link.textContent=`${item.quantity} × ${item.title}${item.variantTitle && item.variantTitle!=='Default Title' ? ` — ${item.variantTitle}` : ''}`;
          const amount=document.createElement('span');
          amount.textContent=money(item.price * item.quantity);
          li.append(link,amount);list.append(li);
        }
        try {
          const items=GosBundleCore.packItems(selection?.components,module.dataset.packTitle,module.dataset.packHandle,'validation');
          const total=GosBundleCore.packTotal(selection.components);
          const count=items.reduce((n,item)=>n+item.quantity,0);
          module.querySelector('[data-gos-pack-total]').textContent=`${count} produits · Total ${money(total)}`;
          const price=section?.querySelector('[data-product-price]');
          if(price) {const amount=document.createElement('span');amount.className='price__current';amount.textContent=money(total);price.replaceChildren(amount);}
          label.textContent=`AJOUTER LES ${count} PRODUITS AU PANIER`;
          button.disabled=submitting;
          showError('');
        } catch (err) {button.disabled=true;label.textContent='COMPOSITION INDISPONIBLE';showError(err.message);}
      };
      choice?.addEventListener('change',update);
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(submitting || button.disabled) return;
        submitting=true;button.disabled=true;label.textContent='AJOUT…';
        showError('');
        try {
          const items=GosBundleCore.packItems(selection?.components,module.dataset.packTitle,module.dataset.packHandle,crypto.randomUUID());
          const root=window.Shopify?.routes?.root || '/';
          const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          if(!response.ok) {
            const result=await response.json().catch(()=>({}));
            throw new Error(result.description || 'Ajout impossible. Vérifiez votre panier avant de réessayer.');
          }
          window.location.assign(document.documentElement.dataset.cartUrl || `${root}cart`);
        } catch(err) {
          submitting=false;update();showError(err.message || 'Ajout impossible. Vérifiez votre panier avant de réessayer.');
        }
      });
      update();
    });
  }
  document.addEventListener('DOMContentLoaded',()=>initialize());
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
